import { config } from 'lib-shared-backend-config';
class Fullview {
    start() {
        (function (i, s, o, g) {
            var _a;
            const script = s.createElement('script');
            const first = s.getElementsByTagName('script')[0];
            script.async = true;
            script.src = g;
            (_a = first === null || first === void 0 ? void 0 : first.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, first);
        })(window, document, 'script', `https://install.fullview.io?o=${config.sdk.fullview}`);
    }
    loadUser(profile, organization) {
        window.Fullview.identify(profile.id, {
            name: profile.name,
            email: profile.email,
            role: profile.roles,
            organization: profile.org_id,
            subdomain: organization.subdomain,
            isInTrial: organization.trial_ended_at === null ? true : false,
        });
    }
}
export const fullviewService = new Fullview();
